import { Image } from "antd";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import entete from '../../../assets/img/entete_pool.png';
import { frenchDate, numberToWordsFrench } from "../../../variables/functions";
import { displayNumbers } from "../../../variables/numbersFunctions";
import { DocumentFooter } from "../../../components/docs/DocumentFooter";
import { getCompagnieLogo } from "../../../hooks/useFilesHooks";
import BarreTop from "../../../components/docs/BarreTop";
import axiosInstance from "../../../variables/api/axiosInstance";


const OrdreDeDepense = React.forwardRef((props, ref) => {
    const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);
    const [pool, setPool] = useState({});
    useEffect(() => {
        if (props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL") {
            getCompagnieLogo(props?.sinistre?.contrat?.organisme?.code)
                .then(async (response) => {
                    const imageBytes = await response.arrayBuffer();
                    var blob = new Blob([imageBytes], { type: "image/png" });
                    var imageUrl = URL.createObjectURL(blob);
                    setLogoPreviewUrl(imageUrl);
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            axiosInstance.get("/api/organisme/pool")
                .then((response) => {
                    setPool(response.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        // Add print style for portrait orientation
        const style = document.createElement('style');
        style.innerHTML = `
            @media print {
                @page {
                    size: portrait;
                    margin: 0;
                }
            }
        `;
        document.head.appendChild(style);

        console.log("Decaissement:", props?.decaissement);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    const isPool = props?.sinistre?.contrat?.organisme?.typeOrganisme === "POOL";


    return (
        <div ref={ref} style={{
            width: "210mm",
            minHeight: "297mm",
            margin: "0 auto",
            backgroundColor: "white",
            fontFamily: "'Comic Sans MS', 'Comic Sans', cursive, sans-serif",
            fontSize: "12px",
            position: "relative",
            boxSizing: "border-box"
        }}>
            {/* Header - Full Width */}
            <div style={{
                textAlign: "center",
                marginBottom: "10px",
                paddingBottom: "10px",
                paddingLeft: "0",
                paddingRight: "0"
            }}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 0px",
                    }}
                >
                    {props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL" && (
                        <Image
                            src={logoPreviewUrl}
                            style={{
                                width: "100%",
                                height: "105px",
                            }}
                        />
                    )}

                    <Image
                        src={entete}
                        style={{
                            width: "100%",
                            height: "105px",
                        }}
                    />
                </div>
                <BarreTop />
            </div>

            {/* Content Area with Padding */}
            <div style={{ padding: "0 20mm" }}>
                {/* Title */}
                <div style={{
                    textAlign: "center",
                    marginBottom: "20px"
                }}>
                    <h2 style={{
                        fontSize: "22px",
                        textDecoration: "underline",
                        WebkitTextStroke: "0.5px black",
                        fontWeight: "bold",
                        margin: 0
                    }}>
                        Ordre de dépense
                    </h2>
                </div>

                {/* Info Table - Right Aligned */}
                <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "30px"
                }}>
                    <table style={{
                        fontSize: "13px",
                        lineHeight: "1.8",
                        borderCollapse: "collapse",
                        width: "auto"
                    }} border={1}>
                        <tbody>
                            <tr>
                                <td style={{ padding: "2px 8px", textAlign: "right", border: "1px solid black", whiteSpace: "nowrap" }}>Branche</td>
                                <td style={{ padding: "2px 8px", textAlign: "right", border: "1px solid black" }}>{props?.sinistre?.engin?.categorie?.codeCategorie || "VT"}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: "2px 8px", textAlign: "right", border: "1px solid black", whiteSpace: "nowrap" }}>Sinistre N°</td>
                                <td style={{ padding: "2px 8px", textAlign: "right", border: "1px solid black" }}>{props?.sinistre?.numeroSinistreM || props?.sinistre?.numSinistre || "CX202400027"}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: "2px 8px", textAlign: "right", border: "1px solid black", whiteSpace: "nowrap" }}>Survenu le</td>
                                <td style={{ padding: "2px 8px", textAlign: "right", border: "1px solid black" }}>{frenchDate(props?.sinistre?.dateSinistre) || "07/09/2024"}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: "2px 8px", textAlign: "right", border: "1px solid black", whiteSpace: "nowrap" }}>Montant en FCFA</td>
                                <td style={{ padding: "2px 8px", textAlign: "right", border: "1px solid black" }}>{displayNumbers(Math.trunc(props?.decaissement?.montantGlobal || 150000))}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: "2px 8px", textAlign: "right", border: "1px solid black", whiteSpace: "nowrap" }}>Retenue</td>
                                <td style={{ padding: "2px 8px", textAlign: "right", border: "1px solid black" }}>
                                    {props?.decaissement?.montantPaye
                                        ? displayNumbers(
                                            parseFloat(props?.decaissement?.montantGlobal) -
                                            parseFloat(props?.decaissement?.montantPaye)
                                        )
                                        : "0"}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Main Content */}
                <div style={{
                    fontSize: "13px",
                    lineHeight: "2",
                    marginBottom: "50px",
                    textAlign: "justify"
                }}>
                    <p style={{ margin: "0 0 20px 0" }}>
                        Veuillez payer à l'ordre de{" "}
                        <b style={{ textTransform: "uppercase", fontFamily: "'Comic Sans MS Bold', 'Comic Sans MS', sans-serif", WebkitTextStroke: "0.5px black", fontWeight: "bold" }}>
                            {
                                props?.decaissement?.beneficiaireMoral
                                    ? props.decaissement.beneficiaireMoral.nom
                                    : props?.decaissement?.beneficiaire?.prenom
                                        ? `${props.decaissement.beneficiaire.nom} ${props.decaissement.beneficiaire.prenom}`
                                        : props?.decaissement?.beneficiaire?.nom || ""
                            }
                        </b>
                        <b style={{ textTransform: "uppercase", fontFamily: "'Comic Sans MS Bold', 'Comic Sans MS', sans-serif", WebkitTextStroke: "0.5px black", fontWeight: "bold" }}>
                            {props?.decaissement?.representant ? ` P/C ${props.decaissement.representant}` : ""}
                        </b>
                    </p>
                    <p style={{ margin: "0 0 20px 0" }}>
                        La somme de{" "}
                        <b style={{ textTransform: "uppercase", fontFamily: "'Comic Sans MS Bold', 'Comic Sans MS', sans-serif", fontWeight: "700" }}>
                            {numberToWordsFrench(props?.decaissement?.montantGlobal || 150000)}
                        </b> FCFA
                    </p>
                    <p style={{ margin: "0 0 20px 0" }}>
                        Représentant {props?.decaissement?.motifReglement || ""}
                    </p>
                    {props?.decaissement?.formuleDeFin ? (
                        <p style={{
                            margin: "0 0 20px 0",
                            fontStyle: "italic",
                            textAlign: "justify"
                        }}>
                            {props.decaissement.formuleDeFin}
                        </p>
                    ) : null}
                </div>

                {/* Date */}
                <div style={{
                    textAlign: "center",
                    fontSize: "13px",
                    marginBottom: "100px"
                }}>
                    Fait à Lomé, le {frenchDate(props?.decaissement?.createdAt || new Date())}
                </div>

                {/* Signatures */}
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "80px",
                    marginTop: "60px",
                    fontSize: "13px"
                }}>
                    <div style={{ textAlign: "center" }}>
                        <div style={{
                            textDecoration: "underline",
                            marginBottom: "10px",
                            fontWeight: "bold",
                            WebkitTextStroke: "0.5px black",
                        }}>
                            {isPool ? pool?.responsable : props?.sinistre?.contrat?.organisme?.responsable || "-"}
                        </div>
                        <div style={{ fontWeight: "normal" }}>Directeur Général</div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                        <div style={{
                            textDecoration: "underline",
                            marginBottom: "10px",
                            fontWeight: "bold",
                            WebkitTextStroke: "0.5px black",
                        }}>
                            {isPool ? "Yao Contant DJEKET" : "-"}
                        </div>
                        <div style={{ fontWeight: "normal" }}>
                            {isPool
                                ? "Président du Conseil d'Encadrement"
                                : "Chef Service Sinistres"}
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer - Full Width */}
            <div style={{
                position: "absolute",
                bottom: "1mm",
                left: "0",
                right: "0",
                fontSize: "1px",
                textAlign: "center",
                color: "#666",
                borderTop: "1px solid #ccc",
                paddingTop: "0px"
            }}>
                <DocumentFooter />
            </div>
        </div>
    );
});

OrdreDeDepense.propTypes = {
    decaissement: PropTypes.object,
    sinistre: PropTypes.object,
};

export default OrdreDeDepense;